// import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { Controlled as ControlledZoom } from "react-medium-image-zoom";
import { useCallback, useState } from "react";

export default function ImgPreview({ path }: { path: string }) {
	const getImg = (path: string) => {
		return "https://web-cdn.rockflow.tech" + path;
	};
	const [isZoomed, setIsZoomed] = useState(false);

	const handleZoomChange = useCallback((shouldZoom: boolean | ((prevState: boolean) => boolean)) => {
		setIsZoomed(shouldZoom);
	}, []);

	return (
		<>
			<ControlledZoom
				isZoomed={isZoomed}
				onZoomChange={handleZoomChange}
				wrapElement="div"
				classDialog="address-proof-zoom-bg"
			>
				<img src={getImg(path)} className="w-full border-none block mb-4 object-contain" alt="back" />
			</ControlledZoom>

			<style jsx global>{`
				.address-proof-zoom-bg [data-rmiz-modal-overlay],
				.address-proof-zoom-bg [data-rmiz-modal-img] {
					transition-duration: 0.2s;
					transition-timing-function: linear;
				}
				.address-proof-zoom-bg [data-rmiz-modal-overlay="hidden"] {
					background-color: rgb(56, 58, 89, 0);
				}
				.address-proof-zoom-bg [data-rmiz-modal-overlay="visible"] {
					background-color: rgb(56, 58, 89, 1);
				}
				.address-proof-zoom-bg [data-rmiz-btn-unzoom] {
					background-color: #bd93f9;
					color: #000;
					display: none;
				}
				.address-proof-zoom-bg [data-rmiz-btn-unzoom]:focus-visible {
					outline-offset: 0.4rem;
					outline: 0.2rem solid #bd93f9;
				}
			`}</style>
		</>
	);
}
